// What winning Royales earns, shared by the edge-server (which checks and grants)
// and the client (which shows them). A reward is an achievement the player
// OPENS themselves ("unboxes") once they have the wins for it: that is when the
// Golden Eggs and the item are granted, once per account. Only wins count:
// placing second earns a line in your history, not a reward.
//
//  - wins:  Royale wins needed
//  - eggs:  Golden Eggs granted when it is opened
//  - item:  an exclusive cosmetic granted with it (shop catalog id), if any
export var CROWN_REWARDS = [
    { id: "crown_1", wins: 1, name: "First crown", eggs: 10, item: { kind: "head", id: "crown" } },
    { id: "crown_5", wins: 5, name: "Five crowns", eggs: 25 },
    { id: "crown_25", wins: 25, name: "Twenty-five crowns", eggs: 50 },
    { id: "crown_75", wins: 75, name: "Seventy-five crowns", eggs: 75 },
    { id: "crown_200", wins: 200, name: "Two hundred crowns", eggs: 100 },
];

export function crownReward(id) {
    for (var i = 0; i < CROWN_REWARDS.length; i++) {
        if (CROWN_REWARDS[i].id === id) { return CROWN_REWARDS[i]; }
    }
    return null;
}

// The rewards a player with `wins` wins may open now: earned, not yet opened.
// `opened` is the list of reward ids they already opened.
export function openableCrownRewards(wins, opened) {
    var done = opened || [];
    return CROWN_REWARDS.filter(function (r) { return wins >= r.wins && done.indexOf(r.id) === -1; });
}

// The next reward still ahead of a player with `wins` wins, or null.
export function nextCrownReward(wins) {
    for (var i = 0; i < CROWN_REWARDS.length; i++) {
        if (wins < CROWN_REWARDS[i].wins) { return CROWN_REWARDS[i]; }
    }
    return null;
}
